import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

// Heroicons mini "user" (single-person silhouette) - Figma's icon for a confirm dialog whose
// selection is exactly one team member (Remove/Delete invitation, singular case). Not
// Icons/User.tsx, which is a static <img> (src/assets/User.svg) that can't sit white-on-a-
// coloured-circle - this one uses fill="currentColor" throughout instead.
const UserSolo = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ size, variant, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none">
    <path
      d="M24.0002 19.2C27.9766 19.2 31.2002 15.9765 31.2002 12C31.2002 8.0236 27.9766 4.80005 24.0002 4.80005C20.0237 4.80005 16.8002 8.0236 16.8002 12C16.8002 15.9765 20.0237 19.2 24.0002 19.2Z"
      fill="currentColor"
    />
    <path
      d="M8.31661 34.7845C7.84888 36.0038 8.26663 37.3704 9.29827 38.1711C13.3599 41.3233 18.461 43.2001 24.0005 43.2001C29.5456 43.2001 34.6514 41.3195 38.7151 38.1614C39.7462 37.3601 40.1631 35.9932 39.6945 34.7742C37.2723 28.4725 31.1623 24 24.0076 24C16.849 24 10.7361 28.4774 8.31661 34.7845Z"
      fill="currentColor"
    />
  </svg>
);

export default UserSolo;
